
import React, { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Mail } from "lucide-react";
import { resetPassword } from "@/lib/auth";
import { translateAuthError } from "@/lib/auth-errors";

interface ResetRequestFormProps {
  onSuccess: (email: string) => void;
  onCancel: () => void;
}

const ResetRequestForm = ({ onSuccess, onCancel }: ResetRequestFormProps) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();
  
  const handleRequestReset = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      console.log("Password reset request initiated for:", email);
      
      const { error } = await resetPassword(email);
      if (error) throw error;
      
      console.log("Password reset request successful");
      
      onSuccess(email);
      toast({
        title: "Parooli lähtestamise link saadetud",
        description: "Palun kontrolli oma postkasti",
      });
    } catch (error: any) {
      console.error("Password reset request failed:", error);
      
      toast({
        title: "Parooli lähtestamine ebaõnnestus",
        description: translateAuthError(error.message),
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold text-center mb-6">Parooli lähtestamine</h2>
      <p className="text-center text-gray-600 mb-6">
        Sisesta oma e-posti aadress ja saadame sulle parooli lähtestamise lingi.
      </p>
      
      <form onSubmit={handleRequestReset} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="reset-email">E-post</Label>
          <div className="relative">
            <Input
              id="reset-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="sinu.email@näide.ee"
              className="pl-10"
              required
            />
            <Mail className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
          </div>
        </div>
        
        <Button 
          type="submit" 
          className="w-full mt-6"
          disabled={loading}
        >
          {loading ? "Saadan..." : "Saada lähtestamise link"}
        </Button>
        
        <Button 
          type="button" 
          variant="outline" 
          className="w-full"
          onClick={onCancel}
        >
          Tagasi sisselogimise lehele
        </Button>
      </form>
    </div>
  );
};

export default ResetRequestForm;
